module.exports = __webpack_public_path__ + "img/arrive-head.49ca7c0f.png";